import React from 'react'

import CreatorThumbnail from './CreatorThumbnail'

import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'

export const CREATOR_PROFILE_SIZES = ['small', 'medium', 'large'] as const
export type CreatorProfileSize = (typeof CREATOR_PROFILE_SIZES)[number]

interface Props {
  name: string
  subheading?: string
  size: CreatorProfileSize
  imgId?: string
}

function CreatorProfile({ size, name, subheading, imgId }: Props) {
  return (
    <Group direction="horizontal" gap={8} verticalAlign="stretch">
      <CreatorThumbnail imgId={imgId} size={size} />
      <Group direction="vertical" gap={2} verticalAlign="center">
        <BodyText variant="medium" colour="neutral-one">
          Curated by{' '}
          <BodyText variant="medium" as="span" weight="bold">
            {name}
          </BodyText>
        </BodyText>
        {subheading && size !== 'small' && (
          <BodyText
            variant={size === 'large' ? 'medium' : 'small'}
            colour="neutral-three"
          >
            {subheading}
          </BodyText>
        )}
      </Group>
    </Group>
  )
}

export default React.memo(CreatorProfile)
